import Vue from 'vue';
import Router from 'vue-router';
import store from './store'
// import Entities from 'Components/admin/Entities.vue';
import Auth from 'Api/auth';
import Login from './views/Login.vue';
import Dashboard from './views/Dashboard.vue';
import ManageCalls from './views/ManageCalls.vue';
import History from './views/History.vue';
import ManageUsers from './views/ManageUsers.vue';
import UserCalls from './views/UserCalls.vue';

import {
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY
} from "Constants/settings";
// import EventBus from './utils/event-bus';
// EventBus.$emit('resetSessionTimer');

Vue.prototype.$auth = Auth;
Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Login,
    // },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: { requiresAuth: true },

      children: [
        {
          path: '/dashboard/userCalls',
          name: 'userCalls',
          component: UserCalls,
          meta: { requiresAuth: true },
        },
        {
          name: 'home',
          path: '/',
          component: ManageCalls,
          // meta: { requiresAdmin: true },
        },
        {
          name: 'manage',
          path: '/dashboard/manage',
          component: ManageCalls,
          meta: { requiresAdmin: true },
        },
        // {
        //   name: 'history',
        //   path: '/dashboard/history',
        //   component: History,
        //   meta: { requiresAdmin: true },
        // },
        {
          name: 'manageUsers',
          path: 'users',
          component: ManageUsers,
          meta: { requiresAdmin: true },
        },

      ],
    },

    // {
    //   path: '/admin',
    //   name: 'admin',
    //   component: AdminDashboard,
    //   meta: { requiresAuth: true },
    //   children: [
    //     {
    //       name: 'Entities',
    //       path: 'entities',
    //       component: Entities,
    //     },
    //   ],
    // },
    {
      path: '*',
      redirect: '/dashboard',
    },
  ],
});


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    // const isLoggedIn =localStorage.getItem(ACCESS_TOKEN_KEY) && localStorage.getItem(REFRESH_TOKEN_KEY)
    // console.log('BEFORE ROUTE isLoggedIn: ',isLoggedIn);
    const aToken = localStorage.getItem(ACCESS_TOKEN_KEY);
    const rToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (!store.getters.isLoggedIn && (!aToken && !rToken)) {
    // if (!isLoggedIn) {
      next({ name: 'login' })
    } else {
      // if (to.matched.some(record => record.meta.requiresAdmin)) {
      //   if(!store.getters.isAdmin) {
      //     console.log('Requires Admin permissions');
      //     next({ name: 'home' })
      //   } else {
      //     next() // go to wherever I'm going
      //   }
      // } else {
      //   next() // go to wherever I'm going
      // }
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

// router.beforeEach(Auth.guard());

export default router;
